<template>
    <div>
        <div>
            <CRow>
                <CCol sm="6" style="background-size: cover; display: flex; align-items: center; justify-content: center; min-height: 100vh;" class="bg-white">
                    <CContainer style="max-width: 600px; text-align: left;">
                        <div>
                            <h3 class="custom-24px-500 font-color-171717 text-left">Welcome back!</h3>
                            <p class="custom-16px-400 font-color-9DA4AE mb-4">Enter your email address and password to login</p>
                        </div>
    
                      
    
                        <div v-if="ErrorLogin" class="">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error!</strong> {{ Message }}
                            </CAlert>
                        </div>
    
                        <div class="mt-3">
                            <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-101010">Email</strong>
                            <input type="text" class="custom-input-app mb-2 mt-2" v-model="userEmail" />
                            <br />
                            <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-101010">Password</strong>
                            <input type="password" class="custom-input-app mb-4 mt-2" v-model="userPassword" />
    
                        </div>
    
                        <div class="text-center mt-3 mb-4">
                            <CButton class="custom-border-purple p-2 text-white" v-on:click="trylogin" block size="lg">Login</CButton>
                        </div>
                        <CCol sm="12" class="text-center">
                            <label class="font-color-101010 custom-14px-600 text-center text-danger" @click="OpenForgot">Forgot Password</label>
                        </CCol>
                        <img src="../assets/img/or1.png" style="max-width:100%" class="mb-2 mt-3" /> 
                         <!-- <div class="custom-border-line mt-2 mb-4">
                            <div class="text-center" v-on:click="login">
                                <img src="../assets/img/google-symbol1.png" alt="Google Login" style="max-width:20px" />
                                <span class="custom-14px-600 font-color-171717 ml-2">{{ lblGoogle }}</span>
                            </div>
                        </div> -->

                        <div id="g_id_signin" class="text-center mt-2"></div>



                        <div style="position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%); width: 100%; text-align: center;">
            <p class="custom-18px-500">Don’t have an account? <span class="font-color-928AFD" @click="GoToCreateAcc()">Create account</span></p>
        </div>


                  
    
    
    
    
    
    
                    </CContainer>
                </CCol>
    
                <CCol sm="6" lg="6" class="d-sm-down-none"
       style="background-size: cover; background-position: center; min-height: 100vh;" 
       :style="{ backgroundImage: `url(${backgroundUrl})` }">
                <CRow class="mt-3 p-3">
                    <CCol sm="6">
                        <img src="../assets/img/Interviewerr White.png" height="32" class="m-2" alt="Surpriz.ing company logo"/> <span class="custom-20px-500 text-white">SurPriz.ing</span>
                    </CCol>
                    <CCol sm="6"></CCol>
                    <CCol sm="12">
                        <h3 class="custom-32px-700 text-white mt-5">Effortless e-Voucher Distribution</h3> 
                        <p class="custom-18px-400 text-white">Easily generate and send personalized e-Vouchers automatically, encouraging customer engagement and repeat business with every interaction</p>
                    </CCol>
                </CRow>
                </CCol>
    
            </CRow>
    
        </div>
        <div class="d-md-none d-lg-none d-sm-down-none">
            <div  style="background-size: cover; background-position: center; min-height: 100vh;" 
       :style="{ backgroundImage: `url(${backgroundUrlApp})` }"></div>
        </div>
    
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Your account is succesfully registered</h3>
                    <CButton class="custom-border-purple text-white" @click="closePopup"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
    
            </div>
        </div>
    
    
    </div>
</template>


<script>
import Vue from "vue";


import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgsignin.png";
import backgroundUrlApp from "../assets/img/bgapp.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeaderBlack.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrlApp,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,



            name: "",
            email: "",
            phone: "",
            password: "",
            selectedUser: this.$route.query.type === 'individual' ? 'individual' : 'company',
            website: "",
            detail: "",



            userOptions: [{

                id: 1,
                UserType: "Candidate",


            }, ],
            isLanguagePopupVisible1: false,
            isLanguagePopupVisible2: false,

            userEmail: "",
            userPassword: "",


            ErrorLogin: false,
            Message: "",

            lblGoogle: "Sign In with Google",

        };
    },
    created() {
        // Check if the 'type' query parameter is present in the URL
        const type = this.$route.query.type;
        if (type === 'individual') {
            // If the type is 'individual', set the selectedUser to 'individual'
            this.selectedUser = 'individual';
        } else if (type === 'company') {
            // If the type is 'company', set the selectedUser to 'company'
            this.selectedUser = 'company';
        } else {
            // Handle other cases, if necessary
        }
    },
    mounted() {
    this.loadGoogleScript();
  },



    methods: {
        updateSelection(selection) {
            this.selectedUser = selection;
        },
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            this.$router.push("HowItWork");
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
        },

        trylogin() {
            this.ErrorLogin = false;

            const formData = new FormData();

            if (this.userEmail === "" || this.userPassword === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("Email", this.userEmail);
                formData.append("Password", this.userPassword);

                this.$API
                    .post(this.$LoginToken, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.ErrorLogin = true;
                        }
                        if (response.status == 200) {
                            const userData = {
                            id: response.data.user?.id || response.data.userId,
                            email: response.data.user?.email || response.data.email,
                            token: response.data.token,
                            type: response.data.type // 👈 capture type from API
                        };


                        localStorage.setItem("authToken", userData.token);
                        localStorage.setItem("user", JSON.stringify(userData));

                        this.userId = userData.id;
                        this.email = userData.email;

                        console.log("✅ Logged in:", this.userId, this.email);



                            if (response.status !== 400) {

                                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                    //  const userId = response.data.data.userType;
                                    // console.log("userid", userId);

                                   // this.$router.push("Home");
                                   if (userData.type === "company") {
        this.$router.push("/cashier"); // redirect cashier
      } else {
        this.$router.push("/home"); // fallback for other types
      }

                                }
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.ErrorLogin = true;
                            }
                        } else {
                            this.Loading = false;
                            this.ErrorLogin = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.ErrorLogin = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        registerAccount() {

            const formData = new FormData();

            if (this.Name === "" || this.Email === "" || this.Phone === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.$route.query.phone);
                formData.append("userType", this.selectedUser);
                formData.append("password", this.password);
                formData.append("website", this.website);
                formData.append("detail", this.detail);
                formData.append("countryId", this.$route.query.countryid);




                this.$API
                    .post(this.$Register, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {

                                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                    this.isLanguagePopupVisible1 = true;
                                }


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        GoToHomeUser() {
            this.$router.push("/Dashboard");
        },
        loadGoogleScript() {
      if (!window.google) {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.onload = this.initGoogleSignIn;
        document.head.appendChild(script);
      } else {
        this.initGoogleSignIn();
      }
    },

    initGoogleSignIn() {
      window.google.accounts.id.initialize({
        client_id: "20319378015-mf0mi472v5n6i9926q0nkgf6jqrj9tgv.apps.googleusercontent.com",
        callback: this.handleGoogleLogin,
      });

      window.google.accounts.id.renderButton(
        document.getElementById("g_id_signin"),
        {
            theme: "outline",
            size: "large",
            width: "100%", // Ensures full width
        }
        );
    },

    async handleGoogleLogin(response) {
      const idToken = response.credential;
      console.log("Google ID Token:", idToken);

      try {
        const res = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
        if (res.status === 200) {
          const user = res.data;
          this.SetSession(idToken, user);
        } else {
          console.error("Failed to fetch user info:", res);
        }
      } catch (error) {
        console.error("Error during Google login:", error);
      }
    },
       
        async verifyScopes(accessToken) {
            try {
                const response = await fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=${accessToken}`);
                const tokenInfo = await response.json();

                console.log('Token Info:', tokenInfo);

                if (tokenInfo.scope.includes('https://www.googleapis.com/auth/user.phonenumbers.read')) {
                    console.log('Scope is present in the token.');
                } else {
                    console.error('Scope is missing in the token.');
                }
            } catch (error) {
                console.error('Error verifying scopes:', error);
            }
        },
        async getUserInfo(accessToken) {
            try {
                const response = await fetch('https://people.googleapis.com/v1/people/me?personFields=phoneNumbers,addresses,emailAddresses,names', {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                const userData = await response.json();

                console.log('User Data:', userData);

                const phoneNumber = userData.phoneNumbers ?.length > 0 ? userData.phoneNumbers[0].value : 'No phone number available';
                const country = userData.addresses ?.length > 0 ? userData.addresses[0].country : 'No country information available';
                const displayName = userData.names ?.length > 0 ? userData.names[0].displayName : 'No display name available';

                return { phoneNumber, country, displayName };
            } catch (error) {
                console.error('Error fetching user info:', error);
                return { phoneNumber: 'Error', country: 'Error' };
            }
        },
        async getUserEmail(idToken, username) {
            this.lblGoogle = "Google";
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    this.SetSession(idToken, this.user, username);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        // async SetSession(idToken, user, username) {
        //     this.lblGoogle = "Processing";
        //     console.log("username:" + username)
        //     try {
        //         const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
        //         console.log("Response:", response);
        //         if (response.status === 202) {

        //             //this.$router.push("JoinUs?email=" + this.user);
        //             this.registerAccountGoogleUser(user, username, idToken);

        //             this.SetSession(idToken, user, username);


        //         } else if (response.status === 200) {
        //             this.lblGoogle = "Processing";
        //             const userData = response.data;
        //             console.log("User Data:", userData);
        //             const userType = response.data.data.userType;
        //             console.log("User Type:", response.data.data.userType);
        //             await this.delay(5000);
        //             //this.$router.push("Profile");
        //             const isAuth = await this.UserAuth();
        //             if (isAuth) {
        //                 if (
        //                     this.$route.query.targetUrl != "" &&
        //                     (this.$route.query.targetUrl != null) &
        //                     (this.$route.query.targetUrl != undefined)
        //                 ) {
        //                     this.$router.push(this.$route.query.targetUrl);
        //                 } else {
        //                     this.$router.push("ProfileUser");


        //                 }
        //             } else {
        //                 this.lblGoogle = "Google";
        //                 this.GoToLogin();
        //             }

        //             console.error("Failed to fetch user information:", response);
        //         } else {
        //             this.lblGoogle = "Google";
        //             // Handle other status codes
        //         }
        //     } catch (error) {
        //         console.error("Error fetching user information:", error);
        //         // Handle the error here  this.lblGoogle = "Google";
        //         this.lblGoogle = "Google";
        //     }
        // },
        async SetSession(idToken, user, username) {
    try {
        const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken, {
            withCredentials: true,
        });
        
        if (response.status === 200) {
            console.log("Session set successfully.");
            const isAuth = await this.UserAuth();
            
            if (isAuth) {
                this.$router.push(this.$route.query.targetUrl || "Home");
            } else {
                console.error("Authentication failed.");
                this.lblGoogle = "Authentication failed.";
            }
        } else {
            console.error("Session setup failed:", response);
            this.lblGoogle = "Session Authentication failed.";
        }
    } catch (error) {
        console.error("Error during SetSession:", error);
        this.lblGoogle = "Google";
    }
},
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        OpenForgot() {
            this.$router.push("ForgotPassword");
        },
        GoToSignUp() {
            this.$router.push("JoinUs");

        },
        registerAccountGoogleUser(user, username, idtoken) {

            const formData = new FormData();
            formData.append("name", username);
            formData.append("email", user);
            formData.append("userType", 'individual');




            this.$API
                .post(this.$Register, formData, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        alert('Please update your phone number on your profile');

                        if (response.data.status !== 400) {

                            if (
                                this.$route.query.targetUrl != "" &&
                                (this.$route.query.targetUrl != null) &
                                (this.$route.query.targetUrl != undefined)
                            ) {
                                this.$router.push(this.$route.query.targetUrl);
                            } else {
                                this.$router.push("Profile");
                            }


                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        GoToCreateAcc()
        {
            this.$router.push("CreateAccount");
        }


    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

#g_id_signin {
  width: 100%;
  justify-content: center;
}

#g_id_signin > div {
  width: 100%;
}
</style>